<script setup lang="ts">
import type { CallToAction } from '~~/types/navigation'

const { promo, closeMenu } = defineProps<{
  promo: CallToAction
  closeMenu: () => void
}>()

const state = reactive({
  subscriptionEmail: undefined,
})

function onSubmit() {
  if (!state.subscriptionEmail)
    return
  closeMenu()
  navigateTo({
    path: promo.linkButton?.url,
    query: {
      email: state.subscriptionEmail,
    },
  })
}
</script>

<template>
  <div class="mega-card__body">
    <p class="mega-card__heading">
      {{ promo.title }}
    </p>
    <p
      v-if="!promo.linkSubtitle?.url"
      class="mega-card__sub-head"
    >
      {{ promo.subtitle }}
    </p>
    <p
      v-if="promo.linkSubtitle?.url"
      class="mega-card__sub-head"
    >
      <ULink
        class="underline"
        :to="useCmsUrl(promo.linkSubtitle.url)"
        :locale="false"
      >
        {{ promo.linkSubtitle?.title }}
      </ULink>
    </p>
    <p>{{ promo.description }}</p>
    <div class="flex w-full md:w-auto">
      <UForm
        :state="state"
        class="md:border-med-dark-gray md:border-2 rounded-[13px] flex flex-col gap-[24px] md:flex-row md:gap-0"
        @submit.stop="onSubmit"
      >
        <UFormField
          label=""
          name="subscriptionEmail"
          class="w-full gap-0"
        >
          <UInput
            v-model="state.subscriptionEmail"
            variant="outline"
            size="lg"
            placeholder="Enter your email"
            :ui="{
              base: 'shadow-none rounded-xl md:ring-0 md:bg-transparent focus-visible:ring-0 placeholder:text-gray-400',
            }"
            required
            type="email"
          />
        </UFormField>
        <UButton
          class="cursor-pointer justify-center min-w-20"
          color="primary"
          variant="solid"
          size="lg"
          :label="promo.linkButton?.title"
          type="submit"
        />
      </UForm>
    </div>
  </div>
</template>
